<template>
  <div id="app" :class="{'pang-font': !isDashboard}">
    <router-view />
    <bottom-com v-if="showFooter"></bottom-com>
  </div>
</template>

<script>
import bottomCom from '@/components/bottom'
export default {
  props: {

  },
  components: {
    bottomCom
  },
  computed: {
    isDashboard() {
      const path = this.$route && this.$route.path ? this.$route.path : ""
      return path.startsWith("/dashboard")
    },
    showFooter() {
      return !this.isDashboard
    }
  },
  created() {
    //发送ws
    //在页面加载时读取sessionStorage里的状态信息
    if (localStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem("store"))))
    }
    window.addEventListener("beforeunload", () => {
      localStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  },
  mounted() {

  },
  methods: {

    getUrlName(name) {
      /* eslint-disable */
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    },
  }
}
</script>

<style>
#app.pang-font {
  font-family: 'Pang';
}
.el-message {
    z-index: 200000!important;
}
</style>
